<ng-select [disabled]="DisableComboBox" [placeholder]="placeholder" [attr.name]="ComboBoxName" [clearable]="false"
    (change)="ComboBoxChanged($event)" [(ngModel)]="ComboBoxSelectedValue">
    <ng-option *ngFor="let data of dataArray" [value]="data.Value">{{ data.Name }}</ng-option>
</ng-select>